import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport is at or below a max-width breakpoint, reactively.
 *
 * Defaults to 768px to match @carvana/ds-modal v6's own mobile breakpoint
 * (`breakpoint.sm`), so callers flip at the same point the modal switches
 * between drawer and mobile layouts. Unlike the user-agent based `isMobile`,
 * this responds to window resize and treats a narrow desktop window as mobile.
 */
export const useIsMobileViewport = (maxWidthPx = 768): boolean => {
  const query = `(max-width: ${maxWidthPx}px)`;
  const [isMobileViewport, setIsMobileViewport] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (e: MediaQueryListEvent) => setIsMobileViewport(e.matches);

    setIsMobileViewport(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return isMobileViewport;
};
